import { Accessor, UpdateParameters } from '@deck.gl/core';
import { Texture } from '@luma.gl/core';
import { positionTextureModule, positionTextureModuleName } from '../modules/coast-position-texture';
import hiddable from '../modules/isHiddableModule.js';
import { flightIconUniforms } from './flight-icon-layer-uniforms.js';
import { FlightsIconLayer } from './flight-icon-layer';

type ExtraProps<T> = {
    positionTexture: Texture;
    getId: Accessor<T, number>;
};

export class AnimatedFlightLayer<T> extends FlightsIconLayer<T, ExtraProps<T>> {
    getShaders() {
        const shaders = super.getShaders();
        return {
            ...shaders,
            modules: [...shaders.modules, hiddable, flightIconUniforms, positionTextureModule]
        };
    }

    initializeState() {
        super.initializeState();
        const manager = this.getAttributeManager()!;
        manager.remove(['instancePositions']);
        manager.addInstanced({
            instanceId: {
                size: 1,
                type: 'uint32',
                accessor: 'getId'
            },
            isHidden: {
                size: 1,
                accessor: 'getIsHidden',
                defaultValue: 0.0
            }
        });
    }

    updateState(params: UpdateParameters<this>): void {
        super.updateState(params);
        if (params.changeFlags.propsChanged) {
            this.state.model?.shaderInputs.setProps({
                [positionTextureModuleName]: this.props
            });
        }
    }
}
